import { LOCAL } from "@/store/mutations";
import { precisionRound } from "@/lib/precision-round";

const { SET_SCORE, STORE_SCORE_CHANGE } = LOCAL;

export default {
	namespaced: true,
	state: () => ({
		id: null,
		name: "",
		value: 0,
		change: 0,
	}),
	getters: {
		change: (state) => {
			let meterChangeString = "decreased";
			meterChangeString = state.change === 0 ? "unchanged" : meterChangeString;
			meterChangeString = state.change > 0 ? "increased" : meterChangeString;

			return meterChangeString;
		},
	},
	actions: {
		calculate({ dispatch, rootGetters }, score) {
			const targetPercentMet = rootGetters[`game/budgets/${score.budget_id}/percentage`] / score.budget.target;
			const impactEarned = ((targetPercentMet - 1) + score.budget.bonus) / score.budget.scalar;
			const amount = Math.max(Math.min(impactEarned, 1), -1) * score.budget.impact;

			dispatch("modify", { amount });
		},
		modify({ dispatch, commit, state }, modifier) {
			const value = state.value + modifier.amount;
			commit(STORE_SCORE_CHANGE, modifier);
			dispatch("update", { value });
		},
		update({ commit }, score) {
			commit(SET_SCORE, score);
		},
	},
	mutations: {
		[SET_SCORE](state, score) {
			const value = precisionRound(score.value, 3);
			state.value = Math.min(Math.max(value, 0), 1);
		},
		[STORE_SCORE_CHANGE](state, change) {
			state.change = change.amount;
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/game/scores/single.store.js